import React, { Fragment, useEffect, useRef, useState } from 'react';

import { Link } from 'react-router-dom';

// import FeePicker from './FeePickerFocus';
import IrregularChoice from './IrregularChoice.js';
import RefractiveServices from './RefractiveServices.js';
import RbaChoice from './RbaChoice.js';
import FinancialChoice from './FinancialChoice.js'
import SliderLanguage from '../partials/SliderLanguage.js'
import Choice1 from '../choices/Choice1'
import api from "../services/api";

export default function LensPicker ( props ) {

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const selectedOptionRef = useRef(null);
  const containerRef = useRef(null);



  let videosList = props.spanish && props.spanish === true 
  ? { // Spanish links
      refractiveDefault: "https://player.vimeo.com/video/1118217995?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveCataract: "https://player.vimeo.com/video/1118217995?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveToricFar: "https://player.vimeo.com/video/1118218062?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveToricNear: "https://player.vimeo.com/video/1118217983?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveFar: "https://player.vimeo.com/video/1118218062?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveNear: "https://player.vimeo.com/video/1118217983?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveEdof: "https://player.vimeo.com/video/1118218048?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveTrifocal: "https://player.vimeo.com/video/1118218053?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      standardLens: "https://player.vimeo.com/video/1118218010?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      irregular: "https://player.vimeo.com/video/1121314946?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      rba: "https://player.vimeo.com/video/1118218027?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      financialNoStandardSurgery: "https://player.vimeo.com/video/1160545387?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      financialWithStandardSurgery: "https://player.vimeo.com/video/1160545381?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    }
  : { //English links
      refractiveDefault: 'https://player.vimeo.com/video/1130671210?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
      refractiveCataract: "https://player.vimeo.com/video/1130671210?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      refractiveToricFar: 'https://player.vimeo.com/video/1091314341?h=a1e10601fe&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
      refractiveToricNear: 'https://player.vimeo.com/video/1105779646?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
      refractiveFar: 'https://player.vimeo.com/video/1091314341?h=a1e10601fe&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
      refractiveNear: 'https://player.vimeo.com/video/1105779646?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
      refractiveEdof: 'https://player.vimeo.com/video/1095450417?h=6982980e01&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
      refractiveTrifocal: 'https://player.vimeo.com/video/1095450420?h=0759afed56&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479',
      standardLens: "https://player.vimeo.com/video/1118218041?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      irregular: "https://player.vimeo.com/video/1081548515?h=f92ba23a82&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      rba: "https://player.vimeo.com/video/1095452968?h=cbc695c5e4&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      financialNoStandardSurgery: "https://player.vimeo.com/video/1160533189?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
      financialWithStandardSurgery: "https://player.vimeo.com/video/1160533249?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
    }

  const handleOptionClick = (l) => {
    props.setLensOption(l);
  };


  //Filter each lens by patient information parameters and then create a list of all valid lens option names

  // Create an array where we can push lenses with warnings
  let lensContraWarningList = [];
  let lensParamWarningList = [];

  

  // Get patient's contraindications
  let ptContraFilter = [];
  props.contraindications?.map(item => {
    if(item.value === 'true'){
      return ptContraFilter.push(item.name)
    } else {
      return null
    }
  });

  // Use map to get a simple array of lens name with contraindications
  let lensDataFilter = props.lensData?.length > 0
  ? props.lensData.map(itemY => {
      let testArr = []
      Object.entries(itemY.contraindications).map(itemZ => {
        if(itemZ[1].value === 'true'){
          return testArr.push(itemZ[1].name)
        } else {
          return null
        }
      })
      return [{name: itemY.lens_name, contraindications: testArr}];
    })
  : []
  


  //Map through lens name with contraindications array and filter out lenses where contraindication matches patient contraindications
  let lensOptionFilter = []
  lensDataFilter.map(item => {
    let lensContraindications = item[0].contraindications
    // console.log(lensContraindications)

    let ptContraindications = ptContraFilter
    // console.log(ptContraindications)

    let lensName = item[0].name
    // console.log(lensName)

    let res = lensContraindications.filter(cha =>
      ptContraindications.includes(cha)
      )
      if(res.length <= 0){
        return lensOptionFilter.push(lensName)
      } else {
        return lensContraWarningList.push({name: lensName, warning: res})
        //nb: can type {...res} to turn res arrays into objects
      }
    }
  )


  //Create an array where we can push qualifying lenses
  let mainLensList = [];
  
  //Map through users lenses pulled from the database
  let mainLensFilter = Object.entries(props.lensData).map((c) => {
      let lens = c[1];
      let warnings = [];
  
      let isPresbyopiaCorrecting = 
        (
          lens.corrects_intermediate_vision === 'Yes' 
          || 
          lens.corrects_near_vision === 'Yes'
        ) 
        &&
        (
          props.topographerAstig * 1 >= lens.lens_astig_min * 1
          ||
          props.biometerAstig * 1 >= lens.lens_astig_min * 1
        ) 
        &&
        (
          props.equipmentPreferenceAstig * 1 <= (lens.lens_astig_max * 1 + lens.lens_astig_residual * 1) 
          ||
          (props.equipmentPreferenceAstig * 1 < lens.cri_max_astig * 1 && props.equipmentPreferenceAstig * 1 > lens.cri_min_astig * 1)
        );
      if (lens.corrects_intermediate_vision === 'Yes' || lens.corrects_near_vision === 'Yes') {
        if (!isPresbyopiaCorrecting) {
          warnings.push(`The residual astigmatism is outside the range for this presbyopia-correcting lens. `);
        }
      }
  
      let isNonPresbyopiaToric = 
        (
          //not trifocal or EDOF
          lens.corrects_intermediate_vision === 'No' 
          && 
          lens.corrects_near_vision === 'No'
        ) 
        &&
        (
          //astigmatism from either the topographer or biometer is more than the minimum astigmatis corrected by this lens
          props.topographerAstig * 1 >= lens.lens_astig_min * 1
          ||
          props.biometerAstig * 1 >= lens.lens_astig_min * 1
        )
        &&
          // make sure average astig is more than min astig corrected by lens
          props.equipmentPreferenceAstig * 1 >= lens.lens_astig_min *1
        &&
        (
          // make sure average astig is less than max astig plus residual astig corrected for/allowed by the lens
          props.equipmentPreferenceAstig * 1 <= (lens.lens_astig_max * 1 + lens.lens_astig_residual * 1) 
          || lens.lens_astig_residual === 'dontuse'
        );
      if (lens.corrects_intermediate_vision === 'No' && lens.corrects_near_vision === 'No' && lens.lens_astig_min > 0) {
        if (!isNonPresbyopiaToric) {
          warnings.push(`The residual astigmatism is outside the range for this toric lens. `);
        }
      }
  
      let isSphericalLens = (lens.corrects_intermediate_vision === 'No' && lens.corrects_near_vision === 'No') &&
        lens.lens_astig_min == 0 &&
        lens.lens_astig_max == 0 &&
        lens.lens_astig_residual === 'dontuse';
  

      let validSphericalAberration = lens.k_sph_ab_residual === 'dontuse' ||
        (props.topographerSphAb * 1 + lens.lens_sph_ab * 1) >= (props.sphAbTarget * 1 - Math.abs(lens.k_sph_ab_residual * 1)) &&
        (props.topographerSphAb * 1 + lens.lens_sph_ab * 1) <= (props.sphAbTarget * 1 + Math.abs(lens.k_sph_ab_residual * 1));
      if (!validSphericalAberration) {
        warnings.push(`The residual spherical aberration limit for this lens is ${lens.k_sph_ab_residual*1} µm, and your eye would have a residual spherical aberration of ${Math.abs(lens.lens_sph_ab * 1 + props.topographerSphAb * 1).toFixed(2)} µm with this lens. `);
      }
  
      let validHOA = lens.lens_hoa_max === 'dontuse' || props.topographerHoa * 1 <= lens.lens_hoa_max * 1;
      if (!validHOA) {
        warnings.push(`The corneal higher order aberration limit for this lens is ${lens.lens_hoa_max} µm, and the cornea of your eye has a higher order aberration of ${props.topographerHoa} µm. `);
      }
  
      
      let validBiometerTopographerAstig = lens.biometer_topographer_astig_max === 'dontuse' ||
        props.biometerTopographerAstigDiff * 1 <= lens.biometer_topographer_astig_max * 1 || (props.biometerAstig*1 <= lens.lens_astig_residual && props.topographerAstig <= lens.lens_astig_residual);
      if (!validBiometerTopographerAstig) {
        warnings.push(`This lens does not work well if the difference in the astigmatism measured on the biometer and topographer measures more than ${lens.biometer_topographer_astig_max} D, and your eye measured ${(props.biometerTopographerAstigDiff).toFixed(2)} D. `);
      }
  
      let validBiometerTopographerAxis = lens.biometer_topographer_axis_max === 'dontuse' ||
        props.equipmentPreferenceAstig * 1 <= lens.lens_astig_residual * 1 ||
        props.biometerTopographerAxisDiff * 1 <= lens.biometer_topographer_axis_max * 1;
      if (!validBiometerTopographerAxis) {
        warnings.push(`This lens does not work well if the difference in the axis between the biometer and topographer measures more than ${lens.biometer_topographer_axis_max} degrees, and your eye measured ${props.biometerTopographerAxisDiff} degrees. `);
      }

      // console.log(warnings)
      // ============================================================================

      // Check if lens is monofocal (not presbyopia-correcting) and NOT sulcus lens and NOT contraindicated
      let isMonofocal = 
      lens.corrects_intermediate_vision === "No" &&
      lens.corrects_near_vision === "No" &&
      lens.lens_astig_max === '0' &&
      lens.lens_astig_min === '0' &&
      lens.lens_location !== 'Sulcus' &&
      !lensContraWarningList.some(warning => warning.name === lens.lens_name);

      if (isMonofocal) {
        // console.log(lens.lens_name)

        // Determine the best monofocal lens based on spherical aberration criteria
        let onlyMonoArr = Object.entries(props.lensData)
          .filter(([_, monoLens]) =>
            monoLens.corrects_intermediate_vision === "No" &&
            monoLens.corrects_near_vision === "No" &&
            monoLens.lens_astig_max === '0' &&
            monoLens.lens_astig_min === '0' &&
            monoLens.lens_location !== 'Sulcus' &&
            !lensContraWarningList.some(warning => warning.name === monoLens.lens_name)
          )
          .map(([_, monoLens]) => ({ name: monoLens.lens_name, sphAb: parseFloat(monoLens.lens_sph_ab), warnings: [] }));

          // console.log(onlyMonoArr)

          if (onlyMonoArr.length > 0) {
            // Find the lens with the spherical aberration closest to zero
            const closestToZeroLensSphAb = onlyMonoArr.reduce((acc, obj) =>
              Math.abs(obj.sphAb) < Math.abs(acc.sphAb) ? obj : acc
            );
            // closestToZeroLensSphAb now holds the lens object with the spherical aberration closest to zero
          
            // console.log(onlyMonoArr)
            
          // Find the lens that brings the residual spherical aberration closest to the target
          const absMinResSphAb = onlyMonoArr.reduce((acc, obj) => {
            const residual = Math.abs(props.sphAbTarget*1 - (obj.sphAb + props.topographerSphAb*1));
            const accResidual = Math.abs(props.sphAbTarget*1 - (acc.sphAb + props.topographerSphAb*1));
            return residual < accResidual ? obj : acc;
          });

          // Determine the best monofocal lens
          const bestMonoLens = (props.topographerHoa*1 > props.hoaMaxPreference*1)
            ? closestToZeroLensSphAb.name
            : absMinResSphAb.name;

          // console.log(bestMonoLens)

          // Add warning if this lens is not the best monofocal
          if (lens.lens_name !== bestMonoLens) {
            warnings.push(`Another monofocal lens achieves the postoperative spherical aberration target better`);
          }
        }
      }
      // ============================================================================
    
  
      if (lens.lens_location !== "Posterior chamber (typical)") {
        warnings.push(`Lens location not in the posterior chamber`);
      }
  
      if (warnings.length > 0) {
        lensParamWarningList.push({ name: lens.lens_name, warnings: warnings });
      } else {
        mainLensList.push(lens.lens_name);
      }
  });
  // console.log('lensContraWarningList: ' + lensContraWarningList)
  // console.log('lensParamWarningList: ' + lensParamWarningList)
  // console.log(mainLensList)

  

  // ==============================================================================
    //Combined the data from lensParamWarningList and data from lensContraWarningList
    const combinedWarningList = new Set([
      ...lensContraWarningList.map(item => item.name),
      ...lensParamWarningList.map(item => item.name)
    ]);

    
    // console.log(combinedWarningList)


    // Filter props.lensData to create the new array by filtering out lenses that are in the combined warning list
      const nextArray = props.lensData && props.lensData.filter(lens =>
        !combinedWarningList.has(lens.lens_name)
      );

      // console.log(nextArray)
    //Sort the lenses in nextArray from trifocal to edof to toric to monofocal
    const sortedArray = nextArray && nextArray.sort((a, b) => {
      // Prioritize lenses that correct both near and intermediate vision
      const aCorrectsBoth = a.corrects_near_vision === 'Yes' && a.corrects_intermediate_vision === 'Yes';
      const bCorrectsBoth = b.corrects_near_vision === 'Yes' && b.corrects_intermediate_vision === 'Yes';

      if (aCorrectsBoth && !bCorrectsBoth) return -1;
      if (!aCorrectsBoth && bCorrectsBoth) return 1;

      // If both or neither correct both visions, prioritize intermediate vision correction
      if (a.corrects_intermediate_vision === 'Yes' && b.corrects_intermediate_vision !== 'Yes') return -1;
      if (a.corrects_intermediate_vision !== 'Yes' && b.corrects_intermediate_vision === 'Yes') return 1;

      // Then sort by astigmatism minimum value (descending order)
      if (a.lens_astig_min * 1 > b.lens_astig_min * 1) return -1;
      if (a.lens_astig_min * 1 < b.lens_astig_min * 1) return 1;

      return 0; // If all criteria are the same, keep original order
    }).reverse();

    // console.log(sortedArray)

    // create chosenArray before pushing new values
    let chosenArray = [];

    // Push sorted lenses to chosenArray
    sortedArray && sortedArray.map(lens => {
      chosenArray.push(lens.lens_name);
    });

    // console.log(chosenArray)
 
    //set ptLensList to be equal to chosenArray so it is available to Paperwork.js
    useEffect(() => {
      props.setPtLensList(chosenArray)
    }, [])

    // add Cataract vision to chosenArray so it doesn't come up as contraindicated in lens dropdown
    const filteredArray = ['Cataract vision', ...chosenArray];

    // console.log(filteredArray)

  // //============================================================================

  // function bestLens(){
  //   if(props.lensOption === chosenArray[0])
  //   {
  //     return props.setChoseBestLens(true)
  //   }
  //   else {
  //     return props.setChoseBestLens(false)
  //   }
  // }


  // //================================================================================


  // //Does chosen array have a trifocal, edof, or toric lens=========================
  const premiumArray = nextArray && nextArray.map((l) => {
    
      // Look for trifocal toric lenses
      if (l.corrects_near_vision === 'Yes' && l.corrects_intermediate_vision === 'Yes' && l.lens_astig_min * 1 > 0) {
          props.setTrifocalToricLens(l)
          return 'hasTrifocalToric'; 
      } else {
        props.setTrifocalToricLens('')
      }

      // Look for trifocal lenses
      if (l.corrects_near_vision === 'Yes' && l.corrects_intermediate_vision === 'Yes') {
          props.setTrifocalLens(l)
          return 'hasTrifocal'; 
      } else {
        props.setTrifocalLens('')
      }

      // Look for edof toric lenses
      if (l.corrects_near_vision !== 'Yes' && l.corrects_intermediate_vision === 'Yes' && l.lens_astig_min *1 > 0) {
          props.setEdofToricLens(l)
          return 'hasEdofToric';
      } else {
        props.setEdofToricLens('')
      }
   
      // Look for edof lenses
      if (l.corrects_near_vision !== 'Yes' && l.corrects_intermediate_vision === 'Yes') {
          props.setEdofLens(l)
          return 'hasEdof';
      } else {
        props.setEdofLens('')
      }

      // Look for Toric lenses
      if (l.lens_astig_min * 1 > 0) {
          props.setToricLens(l)
          return 'hasToric';
      } else {
        props.setToricLens('')
      }
      

      // Look for Monofocal lenses
      if (
          l.corrects_intermediate_vision === "No" &&
          l.corrects_near_vision === "No" &&
          l.lens_astig_max === '0' &&
          l.lens_astig_min === '0'
        ) {
          props.setMonofocalLens(l)
          return 'hasMonofocal';
      }

      // Ensure `.map()` always returns a value
      return 'none';

  });


  // console.log(premiumArray)


  //======Is monofocal sufficient for good distance or near (< astig min of toric lenses)
    const lensArray = Array.isArray(props.lensData)
      ? props.lensData
      : [];

    const smallestToricMin = lensArray
      .filter(lens => {
        const astigMin = Number(lens.lens_astig_min);

        return (
          Number.isFinite(astigMin) &&
          astigMin > 0 &&
          lens.corrects_intermediate_vision === "No" &&
          lens.corrects_near_vision === "No"
        );
      })
      .map(lens => Number(lens.lens_astig_min))
      .sort((a, b) => a - b)[0];


    const isBelowSmallestToricMin =
      Number.isFinite(smallestToricMin) &&
      Number(props.equipmentPreferenceAstig) < smallestToricMin;


      // console.log(smallestToricMin)
      // console.log(isBelowSmallestToricMin)


  //================Scrolling behavior for each card========================

  const [activeIndex, setActiveIndex] = useState(0)
  
  const handleScroll = () => {
    const cards = Array.from(containerRef.current.querySelectorAll('.card'));
    const centerY = props.deviceType === 'portrait' ? window.innerHeight*0.75 : window.innerHeight*0.5;
    const threshold = 50; // px buffer from center
  
    let activeCardId = null;
  
    for (let i = 0; i < cards.length; i++) {
      const rect = cards[i].getBoundingClientRect();
      const cardId = parseInt(cards[i].dataset.id, 10);
  
      const bottomDistanceFromCenter = rect.bottom - centerY;
  
      if (bottomDistanceFromCenter > -threshold) {
        // This card's bottom is not too far above center → still the active one
        activeCardId = cardId;
        break;
      }
    }
  
    if (activeCardId !== null) {
      setActiveIndex(activeCardId);
    }
  };
  
  

  useEffect(() => {
    const container = containerRef.current
    container.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleScroll)

    handleScroll()

    return () => {
      container.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  const cardStyle = (id) => ({
    transition: 'filter 0.3s, opacity 0.3s',
    filter: id === activeIndex ? 'none' : 'grayscale(100%)',
    opacity: id === activeIndex ? 1 : 0.2,
    pointerEvents: id === activeIndex ? 'auto' : 'none',
  });

// =======CRI logic===========================================================
  const[criPicker, setCriPicker]=useState('')


  let criAlwaysOff =
  (
    props.criOffer === 'No'
    ||
    props.lensOption === 'Cataract vision'
    ||
    props.lensCriRequire === "No (don't offer)"
  )
    ? true
    : false

    // console.log("criAlwaysOff: " + criAlwaysOff)

  let criAlwaysOn =
  (
    //Require CRI if corneal astig from preferred machine is greater than lensCriMinAstig and less than lensCriMaxAstig
    (
      props.equipmentPreferenceAstig*1 > props.lensCriMinAstig
      &&
      props.equipmentPreferenceAstig*1 < props.lensCriMaxAstig
      &&
      props.biometerTopographerAxisDiff*1 <= props.lensBiometerTopographerAxisCutoff
    )
    &&
    //and current selection is not "Cataract vision"
    props.lensOption !== 'Cataract vision'
    &&
    //and physician requires CRI for thiss lens (props.lensCriRequire === "Yes (always)")
    props.lensCriRequire === "Yes (always)"
  )
    ? true
    : false

    // console.log("criAlwaysOn: " + criAlwaysOn)

  let criAllowToggle =
  (
    // If corneal astig from preferred machine is greater than lensCriMinAstig and less than lensCriMaxAstig
    (
      props.equipmentPreferenceAstig*1 > props.lensCriMinAstig
      &&
      props.equipmentPreferenceAstig*1 < props.lensCriMaxAstig
      &&
      props.biometerTopographerAxisDiff*1 <= props.lensBiometerTopographerAxisCutoff
    )
    &&
    //and current selection is not "Cataract vision"
    props.lensOption !== 'Cataract vision'
    &&
    //and CRI is optional for this lens
    props.lensCriRequire === "Optional (always offered)"
  )
    ? true
    : false

    // console.log("criAllowToggle: " + criAllowToggle)

    let criModifier = () => {
      if (criAlwaysOff === true){
        setCriPicker('alwaysOff')
      } else if (criAlwaysOff === false && criAlwaysOn === true){
        setCriPicker('alwaysOn')
      } else if (criAlwaysOff === false && criAlwaysOn === false && criAllowToggle === true){
        setCriPicker('allowToggle')
      } else if (criAlwaysOff === false && criAlwaysOn === false && criAllowToggle === false){
        setCriPicker('notNeeded')
      }
    }

    useEffect(() => {
      criModifier();
    });




    //NB: may be able to get rid of useEffect in Lens.js and LensNew.js for props.lensFlacsRequire


    //If cri === true and props.lensFlacsRequire === "Yes (only with CRI)", then props.setCri(true)

    useEffect(() => {
      if(criPicker === 'alwaysOff'){
        props.setCri(false)
        props.setCriAlwaysOn(false)
        props.setCriAllowToggle(false)
      } else if(criPicker === 'alwaysOn' && props.lensFlacsRequire === "Yes (only with CRI)"){
        props.setCri(true)
        props.setCri(true)
        props.setCriAlwaysOn(true)
        props.setCriAlwaysOn(true)
        props.setCriAllowToggle(false)
        props.setCriAllowToggle(false)
      } else if(criPicker === 'alwaysOn'){
        props.setCri(true)
        props.setCriAlwaysOn(true)
        props.setCriAllowToggle(false)
      } else if(criPicker === 'allowToggle'){
        props.setCriAlwaysOn(false)
        props.setCriAllowToggle(true)
      } else if(criPicker === 'notNeeded'){
        props.setCri(false)
        props.setCriAlwaysOn(false)
        props.setCriAllowToggle(false)
      }
    }, [criPicker]);

  


// =========FLACS logic=======================================================

  const[flacsPicker, setFlacsPicker]=useState('')

  let flacsAlwaysOff =
  (
    //current selection is "Cataract vision"
    props.lensOption === 'Cataract vision'
    ||
    //or contraindications
    // props.ptContraFilterLength > 0
    // ||
    //or doctor doesn't offer flacs at all
    props.flacsOffer === 'No'
    ||
    //or doctor doesn't offer flacs for this lens
    props.lensFlacsRequire === "No (don't offer)"
  )
    ? true
    : false

    // console.log(flacsAlwaysOff)

  let flacsAlwaysOn =
  (
    //current selection is not "Cataract vision"
    props.lensOption !== 'Cataract vision'
    &&
    //and physician requires FLACS for this lens (props.lensFlacsRequire === "Yes (always)")
    (
      (
        props.flacsOffer === 'Yes'
        &&
        props.lensFlacsRequire === "Yes (always)"
      )
      ||
      (
        props.flacsOffer === 'Yes'
        &&
        props.criOffer === 'Yes'
        &&
        props.lensFlacsRequire === "Yes (only with CRI)"
        &&
        props.cri === true
      )
    )
  )
    ? true
    : false

    // console.log(flacsAlwaysOn)

  let flacsAllowToggle =
  (
    //current selection is not "Cataract vision"
    props.lensOption !== 'Cataract vision'
    &&
    //and FLACS is optional for this lens
    props.flacsOffer === 'Yes'
    &&
    (
      props.lensFlacsRequire === "Optional (always offered)"
      ||
      (
        props.lensFlacsRequire === "Optional (only offered with CRI)"
        &&
        props.cri === true
      )
    )
  )
    ? true
    : false

    // console.log(flacsAllowToggle)

    let flacsModifier = () => {
      if (flacsAlwaysOff === true){
        setFlacsPicker('alwaysOff')
      } else if (flacsAlwaysOff === false && flacsAlwaysOn === true){
        setFlacsPicker('alwaysOn')
      } else if (flacsAlwaysOff === false && flacsAlwaysOn === false && flacsAllowToggle === true){
        setFlacsPicker('allowToggle')
      } else if (flacsAlwaysOff === false && flacsAlwaysOn === false && flacsAllowToggle === false){
        setFlacsPicker('notNeeded')
      }
    }

    useEffect(() => {
      flacsModifier();
    });

    useEffect(() => {
      if(flacsPicker === 'alwaysOff'){
        props.setFlacs(false)
        props.setFlacsAlwaysOn(false)
        props.setFlacsAllowToggle(false)
      } else if(flacsPicker === 'alwaysOn'){
        props.setFlacs(true)
        props.setFlacsAlwaysOn(true)
        props.setFlacsAllowToggle(false)
      } else if(flacsPicker === 'allowToggle'){
        props.setFlacsAlwaysOn(false)
        props.setFlacsAllowToggle(true)
      } else if(flacsPicker === 'notNeeded'){
        props.setFlacs(false)
        props.setFlacsAlwaysOn(false)
        props.setFlacsAllowToggle(false)
      }
    }, [flacsPicker]);

  // =======Fee Logic==========================================================
  
  const[feeTotal, setFeeTotal]=useState('')
  const[feePhysician, setFeePhysician]=useState('')
  const[feeHospital, setFeeHospital]=useState('')


  let lensTotal = (props.refractiveFee*1 + props.lensHospitalFee*1)


  let feeModifier = () => {
    if (
      props.cri === false
      &&
      props.flacs === false
      &&
      lensTotal === 0
    ){
      setFeeTotal(0)
      setFeePhysician(0)
      setFeeHospital(0)

    // } else if (
    //   props.cri === false
    //   &&
    //   props.flacs === false
    // ){
    //   setFeeTotal(lensTotal)
    //   setFeeHospital(props.lensHospitalFee*1)

    // } else if (
    //   props.cri === false
    //   &&
    //   props.flacs === true
    // ){
    //   setFeeTotal(lensTotal*1)
    //   setFeeHospital(props.lensHospitalFee*1)
    
    // } else if (
    //   props.cri === true
    //   &&
    //   props.flacs === false
    // ){
    //   setFeeTotal(plensTotal*1)
    //   setFeeHospital(props.lensHospitalFee*1)

    // } else if (
    //   props.cri === true
    //   &&
    //   props.flacs === true
    // ){
    //   setFeeTotal(lensTotal*1)
    //   setFeeHospital(props.lensHospitalFee*1)

    // } else {
    //   setFeeTotal('Consult with your doctor')
    // }
    } else if (props.refractive === true){
      setFeeTotal(props.refractiveFee*1+props.lensHospitalFee*1)
      setFeeHospital(props.lensHospitalFee*1)
    } else {
      setFeeTotal(props.lensHospitalFee*1)
      setFeeHospital(props.lensHospitalFee*1)
    }
  }

    useEffect(() => {
      feeModifier()
      props.setOopTotal(feeTotal*1)
      // props.setOopPhysician(feePhysician*1)
      props.setOopHospital(feeHospital*1)
    });



  // =================================================================
  //if EDOF or toric lens would be offered but astigmatism is too low to offer toric or monofococal+cri, then need to offer near far for standard monofocal (helps show finincial choice or not)
  let nearFarStandardMonofocal = 
    (props.trifocalLens || props.edofLens)
    && !props.toricLens
    ? true
    : false

  //=================================================================
  

  const customSelectStyle = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0',
    zIndex: '5',
    borderRadius: '10px',
    background: '#fff',
  };
  

  const optionStyleTrue = {
    width: '380px',
    border: '1px solid #292929',
    margin: '10px 0 0 6px',
    color: '#292929',
    padding: '14px 8px',
    borderRadius: '5px',
    fontSize: '14px',
    fontWeight: '400',
    background: '#f1f1f1',display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
  };

  const optionStyleFalse = {
    width: '380px',
    border: '1px solid #bbb',
    margin: '10px 0 0 6px',
    color: '#888',
    padding: '14px 8px',
    borderRadius: '5px',
    fontSize: '14px',
    fontWeight: '400',
    background: '#FFF',display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
  };

  let liWarnStyle = {
    fontSize: '20px',
  }


  let dysphotopsiaButtonStyle = {
    position: 'absolute',
    right: '0px',
    bottom: '-30px',
    margin: '10px 0 0 0',
    color: '#888',
    fontSize: '14px',
    fontWeight: '400',
    background: '#FFF',
    cursor: 'pointer',
    width: "100%"
  }
  
  
  let compatibleButtonStyle = {
    position: 'absolute',
    right: '0px',
    bottom: '-54px',
    margin: '10px 0 0 0',
    color: '#888',
    fontSize: '14px',
    fontWeight: '400',
    background: '#FFF',
    cursor: 'pointer',
    width: "100%"
  }

  
  let buttonStyleTrue = {
    fontSize: '22px',
    margin: '40px 30px 0 30px',
    padding: '20px',
    background: '#007bff',
    border: '1px solid #007bff',
    borderRadius: '5px',
    color: '#FFF',
    textAlign: 'center',
    textDecoration: 'none',
    cursor: 'pointer'
  }

  

  let videoBoxStyle = props.deviceType === 'portrait'
    ? 
      {
        margin: '80px 0 0 0px',
        padding: '0px',
        borderTop: '2px solid lightgray'
      }
    : 
      {
        margin: '80px 0 0 10px',
        padding: '20px',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, .2), 0 3px 10px 0 rgba(0, 0, 0, .15)',
        borderRadius: '10px',
      }


  let startStyle = {
    textAlign: "center",
    fontSize: '40px',
    margin: '40px 0 0 0',
  }

  let subtitleStyle = {
    textAlign: "center",
    fontSize: '20px',
    margin: '0px 0 0 0',
  }


  const [showReasons, setShowReasons] = useState(false)
    
  let showReasonsStyle = {
    margin: '10px 0 0 10px',
    color: '#888',
    fontSize: '14px',
    fontWeight: '400',
    background: '#FFF',
    cursor: 'pointer',
    width: "100%"
  }


  let blueButton = {
    textDecoration: 'none',
    display: 'block',          // ← add this
    textAlign: 'center',
    color: '#FFF',
    fontSize: '20px',
    background: '#007bff',
    margin: '60px auto',     // ← nicer spacing
    padding: '15px 0',         // ← no side padding needed
    borderRadius: '10px',
    width: '100%',              // ← optional: make it a little narrower inside the 400px container
    cursor: 'pointer',
  }

  let blueButtonInactive = {
    textDecoration: 'none',
    display: 'block',          // ← add this
    textAlign: 'center',
    color: '#FFF',
    fontSize: '20px',
    background: '#007bff',
    margin: '60px auto',     // ← nicer spacing
    padding: '15px 0',         // ← no side padding needed
    borderRadius: '10px',
    width: '100%',              // ← optional: make it a little narrower inside the 400px container
    opacity: '0.2',
    cursor: 'pointer',
  }


//==================================================================
  const updatedLensData = [{ lens_name: 'Cataract vision' }, ...props.lensData];

  // console.log(updatedLensData)
//===================================================================

 //======================================================


  return(
    <Fragment>
      {
        props.userType !== 'qrpt' && props.userType !== 'qrmd'
        ? 
          <>
            <div 
              onClick={()=> props.onPrint()}
              style={{
                textDecoration: 'none',
                display: 'block',          // ← add this
                textAlign: 'center',
                color: '#FFF',
                fontSize: '20px',
                background: '#007bff',
                margin: '120px auto',     // ← nicer spacing
                padding: '15px 0',         // ← no side padding needed
                borderRadius: '10px',
                width: '100%',              // ← optional: make it a little narrower inside the 400px container
                cursor: 'pointer',
              }}>
                {props.spanish === true ? 'Imprimir QR para paciente y doctor' : 'Print QR for patient and surgeon'}
            </div>
          </>
        : null
      }
      {
        props.selectedColor === 'red'
        ? 
        <div
        style={{
          width: '80vw',
          height: '80vh',
          zIndex: '9',
          background: '#efefef',
          borderRadius: '30px',
          opacity: '0.96',
          position: 'fixed',
          padding: '20px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <p 
          style={{
            fontSize: '22px',
          }}
        >
          The 
          <span
            style={{
              fontWeight: '600',
              margin: '0 10px',
            }}
          >
            {props.lensOption} 
          </span>
          would not be a good option for your eye because:
        </p>
          <ul>
          {
          lensParamWarningList && lensParamWarningList.map((w) => (
            w.name === props.lensOption
            ? w.warnings && w.warnings.map((m, i) => (
              <li 
                key={i}
                style={liWarnStyle}
              >
                {m}
              </li>
            ))
            : null
          ))
        }
        {
          lensContraWarningList && lensContraWarningList.map((w) => (
            w.name === props.lensOption
            ? w.warning && w.warning.map((m, i) => (
              <li 
                key={i}
                style={liWarnStyle}
              >
                Your eye has a history of {m}
              </li>
            ))
            : null
          ))
        }
          </ul>
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <div 
              style={buttonStyleTrue}
              onClick={() => props.setSelectedColor('black')}
            >
                Physician override
            </div>
          </div>
      </div>
      
        : null
      }



              <div
                ref={containerRef}
                style={
                  {
                    overflowY: 'scroll',
                    overscrollBehaviorX: 'none',
                    maxHeight: props.deviceType === 'portrait' ? '50vh' : '100vh',
                    paddingRight: props.deviceType === 'full' ? '10px' : '0',
                    margin: '0 0 0px 0',
                  }
                }
              >
                <>
                  <p style={startStyle}>
                    {props.spanish === true ? 'EMPIEZA AQUÍ' : 'START HERE'}
                  </p>
                  <p style={subtitleStyle}>
                    {props.spanish === true ? 'Haga clic en el vídeo' : 'Click on the video below'}
                  </p>
                </>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '10px 0 0 0',
                  }}
                >
                  <SliderLanguage
                    hook={props.spanish}
                    setHook={props.setSpanish}
                  />
                </div>
                
                <div 
                  className="card" 
                  style={cardStyle(0)}
                  data-id={0}
                  >
                  <div
                    style={props.deviceType === 'portrait' 
                      ? 
                        {
                          margin: '20px 0 0 0px',
                          padding: '0px',
                          borderTop: '2px solid lightgray'
                        }
                      : 
                        {
                          margin: '20px 0 0 10px',
                          padding: '20px',
                          boxShadow: '0 4px 8px 0 rgba(0, 0, 0, .2), 0 3px 10px 0 rgba(0, 0, 0, .15)',
                          borderRadius: '10px',
                        }
                      }
                  > 
                    {
                      //check to see if premium lenses are not offered or if astigmatism is more than smallest amount of astigmatism corrected by toric or cri lens. 

                      (
                        (!props.edofLens && !props.trifocalLens && !props.trifocalToricLens && !props.edofToricLens) 
                        &&
                        (!props.toricLens && isBelowSmallestToricMin === false)
                      )
                      ? 
                        <IrregularChoice
                          lensOption={props.lensOption}
                          setLensOption={props.setLensOption}
                          monofocalSelected={props.monofocalSelected}
                          setMonofocalSelected={props.setMonofocalSelected}
                          monofocalLens={props.monofocalLens}
                          lensTargetNear={props.lensTargetNear}
                          setLensTargetNear={props.setLensTargetNear}
                          setRefractive={props.setRefractive}
                          
                          lensParamWarningList={lensParamWarningList}
                          lensContraWarningList={lensContraWarningList}
                          liWarnStyle={liWarnStyle}

                          videosList={videosList}
                          spanish={props.spanish}

                          currentVision={props.currentVision}
                          goalVision={props.goalVision}
                        />
                      :
                      <>
                      <RefractiveServices
                          lensOption={props.lensOption}
                          setLensOption={props.setLensOption}
                          
                          monofocalSelected={props.monofocalSelected}
                          setMonofocalSelected={props.setMonofocalSelected}
                          toricSelected={props.toricSelected}
                          setToricSelected={props.setToricSelected}
                          bestSelected={props.bestSelected}
                          setBestSelected={props.setBestSelected}
                          
                          monofocalLens={props.monofocalLens}
                          toricLens={props.toricLens}
                          edofLens={props.edofLens}
                          edofToricLens={props.edofToricLens}
                          trifocalLens={props.trifocalLens}
                          trifocalToricLens={props.trifocalToricLens}
        
                          lensCorrectsNearVision={props.lensCorrectsNearVision}
                          lensCorrectsIntermediateVision={props.lensCorrectsIntermediateVision}
                          lensTargetNear={props.lensTargetNear}
                          setLensTargetNear={props.setLensTargetNear}

                          refractive={props.refractive}
                          setRefractive={props.setRefractive}

                          nearFarStandardMonofocal={nearFarStandardMonofocal}

                          lensHospitalFee={props.lensHospitalFee}
                          oopTotal={props.oopTotal}
                          setOopTotal={props.setOopTotal}
                          oopPhysician={props.oopPhysician}
                          setOopPhysician={props.setOopPhysician}
                          oopHospital={props.oopHospital}
                          setOopHospital={props.setOopHospital}
                          financing={props.financing}
                          setFinancing={props.setFinancing}
                          refractiveFee={props.refractiveFee}

                          lensParamWarningList={lensParamWarningList}
                          lensContraWarningList={lensContraWarningList}
                          liWarnStyle={liWarnStyle}

                          videosList={videosList}
                          spanish={props.spanish}
                          userType={props.userType}

                          isBelowSmallestToricMin={isBelowSmallestToricMin}

                          currentVision={props.currentVision}
                          goalVision={props.goalVision}
                        />
                      </>
                        
                   }

                  </div>
                </div>

                    <div 
                      className="card" 
                      style={cardStyle(1)}
                      data-id={1}
                    >
                      <div style={videoBoxStyle}>
                        <FinancialChoice
                          lensOption={props.lensOption}
                          trifocalLens={props.trifocalLens}
                          edofLens={props.edofLens}
                          toricLens={props.toricLens}
                          lensHospitalFee={props.lensHospitalFee}
                          refractiveFee={props.refractiveFee}
                          refractive={props.refractive}
                          
                          setLensTargetNear={props.setLensTargetNear}
                          setBestSelected={props.setBestSelected}
                          setMonofocalSelected={props.setMonofocalSelected}
                          setRefractive={props.setRefractive}
                          setLensOption={props.setLensOption}
                          monofocalLens={props.monofocalLens}

                          nearFarStandardMonofocal={nearFarStandardMonofocal}

                          videosList={videosList}
                          spanish={props.spanish}
                        />
                      </div>
                    </div>


                <div 
                  className="card" 
                  style={cardStyle(2)}
                  data-id={2}
                >
                  <div style={videoBoxStyle}>
                    <RbaChoice
                      acknowledgeRba={props.acknowledgeRba}
                      setAcknowledgeRba={props.setAcknowledgeRba}

                      videosList={videosList}
                      spanish={props.spanish}
                    />
                  </div>
                </div>
                
            <>
              <div
                style={{margin: '0 0 0 10px'}}
              >

              
                {
                    props.acknowledgeRba === false || props.lensOption === "Cataract vision"
                    ? props.userType === 'qrpt'
                      ?
                        <div 
                            onClick={() => alert('Make sure you have selected a lens and that you have clicked on the button that says, "I understand and accept the risks of surgery" to proceed')}
                            style={blueButtonInactive}
                        >
                            {props.spanish === true ? 'Continuar' : 'Consent forms (optional)'}
                        </div>
                      : props.userType === 'qrmd'
                      ? 
                        <div 
                            onClick={() => alert('Make sure you have selected a lens and that you have clicked on the button that says, "I understand and accept the risks of surgery" to proceed')}
                            style={blueButtonInactive}
                        >
                            {props.spanish === true ? 'Firmar documentos' : 'Sign paperwork'}
                        </div>
                      :  <>
                            <div 
                              style={{
                                margin: '60px auto',     // ← nicer spacing
                                padding: '15px 0',         // ← no side padding needed
                                width: '100%',              // ← optional: make it a little narrower inside the 400px container
                              }}>
                            </div>
                          </>
                    : props.userType === 'qrpt'
                      ?
                        <Link 
                            to={'/paperwork'}
                            style={blueButton}
                        >
                            {props.spanish === true ? 'Continuar' : 'Consent forms (optional)'}
                        </Link>
                      : props.userType === 'qrmd'
                        ? 
                          <Link
                              to={'/paperwork'} 
                              style={blueButton}
                          >
                              {props.spanish === true ? 'Firmar documentos' : 'Sign paperwork'}
                          </Link>
                        : 
                          <>
                            <div 
                              style={{
                                margin: '60px auto',     // ← nicer spacing
                                padding: '15px 0',         // ← no side padding needed
                                width: '100%',              // ← optional: make it a little narrower inside the 400px container
                              }}>
                                <Link
                                  to={'/paperwork'} 
                                  style={{
                                    color: "#292929",
                                    textDecoration: 'none',        // ← add this
                                    textAlign: 'center',
                                    fontSize: '20px',             // ← optional: make it a little narrower inside the 400px container
                                    cursor: 'pointer',
                                  }}
                              >
                                  {props.spanish === true ? 'Firmar documentos' : 'Sign paperwork'}
                              </Link>
                            </div>
                          </>
                }
              </div>
          </>

      {
        props.userType === 'qrpt'
        ? 
          <div
            style={{height: '200px'}}
          >

          </div>
        : 
        <>
          <div
              style={{position: 'relative', margin: '0px 0 0 10px'}}
          >
              <div 
                  onClick={() => props.handleDysphotopsia()}
                  style={dysphotopsiaButtonStyle}
              >
                  Click to show dysphotopsia
              </div>
          </div>  

          <div
              style={{position: 'relative', margin: '0px 0 150px 10px'}}
            >
            {
              props.onlyCompatible && props.onlyCompatible === true
              ? 
                <div 
                  onClick={() => {
                    props.setOnlyCompatible(false);
                  }}
                  style={compatibleButtonStyle}
                >
                    Click to show all lenses
                </div>
              : 
                <div 
                onClick={() => {
                  props.setOnlyCompatible(true);
                }}
                style={compatibleButtonStyle}
                >
                    Click to hide lens list
                </div>
            }
          </div>    
          <div style={{
              display: 'flex',
              flexDirection: 'column',
              margin: '80px 0 30px 0',
              zIndex: '10',
              borderRadius: '10px',
              background: '#fff',
              width: '100%',
            }}>
            <div style={{
                display: 'flex',
              }}>
              <div style={customSelectStyle}>
        
                {(
                  <div>
                    {(
                        props.onlyCompatible 
                        ? updatedLensData
                            .filter(l => filteredArray.some(lens => lens === l.lens_name))
                            .sort((a, b) => filteredArray.indexOf(a.lens_name) - filteredArray.indexOf(b.lens_name))
                        : updatedLensData
                      ).map((l, i) => {
                      const isFilteredLensData = filteredArray && filteredArray.some(lens => lens === l.lens_name);
                      // console.log(l)
                      const textColor = (isFilteredLensData) ? '#000' : 'red';

                      const key = l.lens_name;

                      return (
                        <React.Fragment key={key}>
                          {
                            // Are compatible filters off?
                            (
                              props.onlyCompatible === false 
                            )
                              ? (
                                <div
                                  ref={
                                    props.lensOption === l.lens_name 
                                    ? selectedOptionRef 
                                    : null
                                  }
                                  onClick={() => {
                                    handleOptionClick(l.lens_name);
                                    props.setSelectedColor(textColor);
                                  }}
                                  onMouseEnter={() => setHoveredIndex(i)}
                                  onMouseLeave={() => setHoveredIndex(null)}
                                  style={{
                                    ...optionStyleFalse,
                                    color: textColor,
                                    ...(props.lensOption === l.lens_name ? optionStyleTrue : {}),
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      width: '100%',
                                    }}
                                  >
                                    <p style={{margin: '0 6px'}}>
                                      {l.lens_name} 
                                    </p>
                                  </div>
                                </div>
                              )
                              : null
                          }
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}    
              </div>
            </div>

            <div style={{position: 'relative', margin: '0px 0 150px 10px'}}>
              <div
                style={{
                  position: 'absolute',
                  right: '0px',
                  bottom: '84px',
                  margin: '10px 0 0 0',
                  color: '#888',
                  fontSize: '14px',
                  fontWeight: '400',
                  background: '#FFF',
                  cursor: 'pointer',
                  width: "100%"
                }}
              >
                  {
                    showReasons === true ? (
                      <div 
                        onClick={() => setShowReasons(false)}
                        style={{
                          margin: '10px 0 0 0px',
                          color: '#888',
                          fontSize: '14px',
                          fontWeight: '400',
                          background: '#FFF',
                          cursor: 'pointer',
                          width: "100%"
                        }}
                      >
                        Click to hide specifics
                      </div>
                    ) : (
                      <div 
                        onClick={() => setShowReasons(true)}
                        style={{
                          margin: '10px 0 0 0px',
                          color: '#888',
                          fontSize: '14px',
                          fontWeight: '400',
                          background: '#FFF',
                          cursor: 'pointer',
                          width: "100%"}}
                      >
                        Click if you want to see the specifics on your eye
                      </div>
                    )
                  }
              
                  { showReasons === true && (
                    <>
                      <ul style={{margin: '10px 0 0 0', fontWeight: '600'}}>Eye measurements:</ul>
                      <ul style={{margin: '0px 0 0 0'}}>
                        Biometer: 
                          <span style={{margin: '0px 30px 0 0'}}></span>
                        {props.biometerAstig} D @ {props.biometerAxis}
                      </ul>
                      <ul style={{margin: '0px 0 0 0'}}>
                        Topographer: 
                          <span style={{margin: '0px 7px 0 0'}}></span>
                        {props.topographerAstig} D @ {props.topographerAxis}
                      </ul>
                      <ul style={{margin: '0px 0 0 0'}}>
                        Sph Ab: 
                          <span style={{margin: '0px 46px 0 0'}}></span>
                        {props.topographerSphAb}
                      </ul>
                      <ul style={{margin: '0px 0 0 0'}}>
                        HOA: 
                          <span style={{margin: '0px 64px 0 0'}}></span>
                        {props.topographerHoa}
                      </ul>
                      {/* <ul style={{margin: '0px 0 0 0'}}>
                        MRx: 
                          <span style={{margin: '0px 7px 0 0'}}></span>
                        {props.power} + {props.cylinder} {props.axis}
                      </ul> */}
                      <ul>
                        {
                          (lensParamWarningList || []).map((param, i) => {
                            const matchingContra = (lensContraWarningList || []).find(
                              contra => contra.name === param.name
                            );
                
                            const combinedWarnings = matchingContra
                              ? `${param.warnings} Your eye's ${matchingContra.warning} limits the use of this lens`
                              : param.warnings;
                
                            return (
                              <li key={i} style={customSelectStyle}>
                                <span style={{ fontWeight: '600' }}>{param.name}</span>: {combinedWarnings}
                              </li>
                            );
                          })
                        }
                      </ul>
                    </>
                  )}
                </div>
              </div> 
              </div> 
          </>
        }
        </div>
  </Fragment>
  )
}






//logic for showing refractive fee conditionally and goes around FinancialChoice
                
                  // {(
                  //   props.lensOption === "Cataract vision" 
                  //   // ||
                  //   // (!props.edofLens && !props.trifocalLens && !props.trifocalToricLens && !props.edofToricLens && !props.toricLens)
                  // )
                  // ? null
                  // :
                  // (props.refractive === true || nearFarStandardMonofocal===false) ? 